"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getOutlookMigrationDiagnosticsRequest_1 = require("owa-service/lib/factory/getOutlookMigrationDiagnosticsRequest");
var getOutlookDotComMigrationDiagnosticsOperation_1 = require("owa-service/lib/operation/getOutlookDotComMigrationDiagnosticsOperation");
var getUserConfiguration_1 = require("owa-session-store/lib/actions/getUserConfiguration");
/**
 * Helper method that creates the GetOutlookMigrationDiagnosticsRequest body
 * @return GetOutlookMigrationDiagnosticsRequest
 */
function createRequestBody() {
    var sessionSettings = getUserConfiguration_1.default().SessionSettings;
    var emailAddresses = [
        {
            EmailAddress: sessionSettings.UserEmailAddress,
            Name: sessionSettings.UserDisplayName,
            RoutingType: 'SMTP',
        },
    ];
    return getOutlookMigrationDiagnosticsRequest_1.default({ SendReportToAddresses: emailAddresses });
}
/**
 * Get rules diagnostics report
 * @return GetOutlookMigrationDiagnosticsRequest
 */
function getOutlookMigrationDiagnosticsService() {
    var requestBody = createRequestBody();
    return getOutlookDotComMigrationDiagnosticsOperation_1.default(requestBody);
}
exports.default = getOutlookMigrationDiagnosticsService;
//# sourceMappingURL=getOutlookMigrationDiagnosticsService.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/services/getOutlookMigrationDiagnosticsService.js
// module id = 5217
// module chunks = 2